import { render, staticRenderFns } from "./RowPropertyConfig.vue?vue&type=template&id=6cac7594"
import script from "./RowPropertyConfig.vue?vue&type=script&lang=js"
export * from "./RowPropertyConfig.vue?vue&type=script&lang=js"
import style0 from "./RowPropertyConfig.vue?vue&type=style&index=0&id=6cac7594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports